'use client';
import { rem } from '@heathmont/moon-utils';
import styled from 'styled-components';
import SocialAuth from '~/client/features/SocialAuth';
import useFeature from '~/client/hooks/feature/useFeature';
import AuthBrandHeading from '~/client/shared/AuthBrandHeading';
import Stack from '~/client/shared/Stack';
import AuthSteps from './AuthSteps';
import AuthStepsEnum from './AuthSteps/AuthStepsEnum';
import useStepByStepAuthContext from './AuthSteps/context/hooks/useStepByStepAuthContext';
import useIsStepByStepEnabled from './AuthSteps/hooks/useIsStepByStepEnabled';
import ProtectedByRecaptcha from '../ProtectedByRecaptcha';
import SocialsKeyLineText from '../Shared/SocialsKeyLineText';

type Props = {
  handleSuccess?: () => void;
  isPopover?: boolean;
};

const ProtectedByRecaptchaWrapper = styled(Stack)`
  bottom: 20px;
  @media only screen and (-webkit-min-device-pixel-ratio: 2) {
    bottom: 0px;
  }
`;

const Authenticate: FC<Props> = ({ handleSuccess, isPopover = false }) => {
  const showSignUpSocialAuth = useFeature('signUpSocialAuth');
  const { step } = useStepByStepAuthContext();
  const isStepByStepRegistrationEnabled = useIsStepByStepEnabled();
  const absolute = !isPopover && step !== AuthStepsEnum.FinishSignUp;
  const showSocialsAuth =
    showSignUpSocialAuth &&
    isStepByStepRegistrationEnabled &&
    step === AuthStepsEnum.EmailOrUsername;

  return (
    <Stack gridGap={rem(16)}>
      <AuthBrandHeading isPopover={isPopover} id="profile.login_or_signup" />
      <Stack>
        <AuthSteps onSubmitHandle={handleSuccess} isPopover={isPopover} />
      </Stack>
      {showSocialsAuth && (
        <Stack marginTop={rem(4)} gridGap={rem(24)}>
          <SocialsKeyLineText
            isStepByStepRegistrationEnabled={isStepByStepRegistrationEnabled}
          />
          <SocialAuth module="login" />
        </Stack>
      )}
      <ProtectedByRecaptchaWrapper
        absolute={absolute}
        templateColumns="330px 1fr"
      >
        <ProtectedByRecaptcha />
      </ProtectedByRecaptchaWrapper>
    </Stack>
  );
};

export default Authenticate;
